module.exports = "/assets/9153fc746c4fc5dc22cf4dcb329b1978.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/A7.png
// module id = 1185
// module chunks = 0